import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=3b116aa5"
import script from "./ProductPicker.vue?vue&type=script&lang=js"
export * from "./ProductPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports